import WordpressRestURI from '@/helpers/WordpressRestURI.js'
export default {
  footerImage: 'https://thinktankapi.multichoice.com/wp-content/uploads/2018/12/Logo-footer.png',
  confirmationOfNominationBody: function (nomination) {
    return '<body leftmargin="0" topmargin="0" marginwidth="0" marginheight="0" style="" cz-shortcut-listen="true">' +
    '<table width="100%" border="0" align="left" cellpadding="10" cellspacing="0">' +
    '<tbody><tr><td id="" align="center" style="text-align: center; color: #FFF; text-transform:uppercase; font-family:Gotham, \'Helvetica Neue\', Helvetica, Arial, sans-serif" bgcolor="#00508F">' +
    '<h2>CONFIRMATION OF NOMINATION</h2></td></tr></tbody></table><table width="600" align="center"><tbody><tr><td>&nbsp;</td></tr><tr>' +
    '<td valign="middle" style="text-align:center">&nbsp;</td>' +
    '</tr><tr><td style="font-family:Gotham, \'Helvetica Neue\', Helvetica, Arial, sans-serif">' +
    '<p>Dear ' + nomination.nominator + '</p>' +
    '<p>Making someone’s day starts with the smallest things. Thank you for your <strong>' +
    nomination.awardName + '</strong> nomination and for seeing others as #weseeyou. This is what MultiChoice is about!' +
    '<p> Keep seeing and celebrating your colleagues every day!</p>' +
    '<p>#weseeyou </p>' +
    '</td></tr><tr><td><hr></td></tr>' +
    '<tr><td><img src="https://thinktankapi.multichoice.com/wp-content/uploads/2018/12/Logo-footer.png" width="600" height="45" alt="Logo compilation"></td></tr><tr><td>&nbsp;</td></tr><tr>' +
    '<td align="center" style="color:#666; font-size:12px; text-align:center; font-family:Gotham, \'Helvetica Neue\', Helvetica, Arial, sans-serif">Copyright © MultiChoice. All rights reserved</td></tr></tbody></table></body>'
  },
  confirmationOfTeamNominationBody: function (nomination) {
    return '<body leftmargin="0" topmargin="0" marginwidth="0" marginheight="0" style="" cz-shortcut-listen="true">' +
    '<table width="100%" border="0" align="left" cellpadding="10" cellspacing="0">' +
    '<tbody><tr><td id="" align="center" style="text-align: center; color: #FFF; text-transform:uppercase; font-family:Gotham, \'Helvetica Neue\', Helvetica, Arial, sans-serif" bgcolor="#00508F">' +
    '<h2>CONFIRMATION OF NOMINATION</h2></td></tr></tbody></table><table width="600" align="center"><tbody><tr><td>&nbsp;</td></tr><tr>' +
    '<td valign="middle" style="text-align:center">&nbsp;</td>' +
    '</tr><tr><td style="font-family:Gotham, \'Helvetica Neue\', Helvetica, Arial, sans-serif">' +
    '<p>Dear ' + nomination.nominator + '</p>' +
    '<p>This E-mail serves as confirmation of your ' +
    nomination.awardName + '</strong> nomination on the <a target="_blank" href="' + WordpressRestURI.frontEndDomain + '">ThinkTank</a> platform.</p>' +
    '<p>Kind regards,<br> VE Nomination Committee</p>' +
    '</td></tr><tr><td><hr></td></tr>' +
    '<tr><td><img src="https://thinktankapi.multichoice.com/wp-content/uploads/2018/12/Logo-footer.png" width="600" height="45" alt="Logo compilation"></td></tr><tr><td>&nbsp;</td></tr><tr>' +
    '<td align="center" style="color:#666; font-size:12px; text-align:center; font-family:Gotham, \'Helvetica Neue\', Helvetica, Arial, sans-serif">Copyright © MultiChoice. All rights reserved</td></tr></tbody></table></body>'
  },
  nominationBodyNoReview: function (nomination) {
    return '<body leftmargin="0" topmargin="0" marginwidth="0" marginheight="0">' +
    '<table width="100%" border="0" align="left" cellpadding="10" cellspacing="0">' +
    '<tr>' +
    '<td id align="center" style="text-align: center; color: #FFF; text-transform:uppercase; font-family:Gotham, \'Helvetica Neue\', Helvetica, Arial, sans-serif" bgcolor="#00508F">' +
    '<h2>REVIEW YOUR NOMINATION</h2></td>' +
    '</tr>' +
    '</table>' +
    '<table width="600" align="center">' +
    '<tr>' +
    '<td colspan="2">&nbsp;</td>' +
    '</tr>' +
    '<tr>' +
    '<td colspan="2" valign="middle" style="text-align:center">&nbsp;</td>' +
    '</tr>' +
    '<tr>' +
    '<td colspan="2" style="font-family:Gotham, \'Helvetica Neue\', Helvetica, Arial, sans-serif">' +
    '<p>Dear ' + nomination.nominee + '</p>' +
    '<p>You have been nominated for <strong>' + nomination.awardName + '</strong> on the ThinkTank platform.</p>' +
    '<p>You stand the chance to <strong>win your share of ' + nomination.prizeMoney + '</strong></p>' +
    '<table bgcolor="#00508F" width="250" align="center" cellpadding="15" cellspacing="0">' +
    '<tr>' +
    '<td style="color:#EEE; text-decoration:none; font-family:\'Helvetica Neue\', Helvetica, Arial, sans-serif; font-size:16px; text-align:center" align="center">' +
    '<a style="color:#EEE; text-decoration:none; font-family:\'Helvetica Neue\', Helvetica, Arial, sans-serif; font-size:15px; text-align:center;" href="' + nomination.reviewLink + '" target="_blank"><strong>REVIEW NOMINATION &raquo;</strong></a></td>' +
    '</tr>' +
    '</table>' +
    '<p>The nomination process closes: ' + nomination.closingDate + '<br>' +
    'Should you require assistance, please email: <a href="mailto:ThinkTank@multichoice.co.za">ThinkTank@multichoice.co.za</a>' +
    '</p>' +
    '<p>Kind regards,<br>' +
    'VE Nomination Committee</p>' +
    '</td>' +
    '</tr>' +
    '<tr>' +
    '<td colspan="2">' +
    '<hr>' +
    '</td>' +
    '</tr>' +
    '<tr>' +
    '<td><img src="https://thinktankapi.multichoice.com/wp-content/uploads/2018/12/Logo-footer.png" width="400" height="33" alt="Logo compilation"/></td>' +
    '<td align="right" style="color:#999; font-size:11px; font-family:Arial, Helvetica, sans-serif">' +
    '<p>Copyright © MultiChoice<br>' +
    'All rights reserved</p>' +
    '</td>' +
    '</tr>' +
    '</table>' +
    '</body>'
  },
  nominationBodyHRBPForRejection: function (nomination) {
    return '<body leftmargin="0" topmargin="0" marginwidth="0" marginheight="0">' +
    '<table width="100%" border="0" align="left" cellpadding="10" cellspacing="0">' +
    '<tr>' +
    '<td id align="center" style="text-align: center; color: #FFF; text-transform:uppercase; font-family:Gotham, \'Helvetica Neue\', Helvetica, Arial, sans-serif" bgcolor="#00508F">' +
    '<h2>PLEASE REVIEW A NOMINATION FOR ONE OF YOUR TEAM MEMBERS</h2></td>' +
    '</tr>' +
    '</table>' +
    '<table width="600" align="center">' +
    '<tr>' +
    '<td colspan="2">&nbsp;</td>' +
    '</tr>' +
    '<tr>' +
    '<td colspan="2" style="font-family:Gotham, \'Helvetica Neue\', Helvetica, Arial, sans-serif">' +
    '<p>As a ' + nomination.position + ', you need to review the declined nomination on ThinkTank. Please review the reason for the decline, investigate if necessary.</p>' +
    '<table bgcolor="#00508F" width="250" align="center" cellpadding="15" cellspacing="0">' +
    '<tr>' +
    '<td style="color:#EEE; text-decoration:none; font-family:\'Helvetica Neue\', Helvetica, Arial, sans-serif; font-size:16px; text-align:center" align="center">' +
    '<a style="color:#EEE; text-decoration:none; font-family:\'Helvetica Neue\', Helvetica, Arial, sans-serif; font-size:15px; text-align:center;" href="' + nomination.reviewLink + '" target="_blank"><strong><u>Click here</u></strong></a> to review nomination</td>' +
    '</tr>' +
    '</table>' +
    '<p>Should you require assistance, please email: <a href="mailto:ThinkTank@multichoice.co.za">ThinkTank@multichoice.co.za</a>' +
    '</p>' +
    '<p>Thank you,<br>' +
    'for #seeing others, as #weseeyou.</p>' +
    '</td>' +
    '</tr>' +
    '<tr>' +
    '<td colspan="2">' +
    '<hr>' +
    '</td>' +
    '</tr>' +
    '<tr>' +
    '<td><img src="' + this.footerImage + '" width="400" height="33" alt="Logo compilation"/></td>' +
    '<td align="right" style="color:#999; font-size:11px; font-family:Arial, Helvetica, sans-serif">' +
    '<p>Copyright © MultiChoice<br>' +
    'All rights reserved</p>' +
    '</td>' +
    '</tr>' +
    '</table>' +
    '</body>'
  },
  nominationBodyWithReview: function (nomination) {
    return '<body leftmargin="0" topmargin="0" marginwidth="0" marginheight="0">' +
    '<table width="100%" border="0" align="left" cellpadding="10" cellspacing="0">' +
    '<tr>' +
    '<td id align="center" style="text-align: center; color: #FFF; text-transform:uppercase; font-family:Gotham, \'Helvetica Neue\', Helvetica, Arial, sans-serif" bgcolor="#00508F">' +
    '<h2>REVIEW YOUR NOMINATION</h2></td>' +
    '</tr>' +
    '</table>' +
    '<table width="600" align="center">' +
    '<tr>' +
    '<td colspan="2">&nbsp;</td>' +
    '</tr>' +
    '<tr>' +
    '<td colspan="2" valign="middle" style="text-align:center">&nbsp;</td>' +
    '</tr>' +
    '<tr>' +
    '<td colspan="2" style="font-family:Gotham, \'Helvetica Neue\', Helvetica, Arial, sans-serif">' +
    '<p>Dear ' + nomination.nominee + '</p>' +
    '<p>You’ve been amazing! </p>' +
    '<p>And that is why you’ve been nominated for <strong>' + nomination.awardName + '</strong>.</p>' +
    '<p>Thank you, we value the difference you make.</p>' +
    '<table bgcolor="#00508F" width="250" align="center" cellpadding="15" cellspacing="0">' +
    '<tr>' +
    '<td style="color:#EEE; text-decoration:none; font-family:\'Helvetica Neue\', Helvetica, Arial, sans-serif; font-size:16px; text-align:center" align="center">' +
    '<a style="color:#EEE; text-decoration:none; font-family:\'Helvetica Neue\', Helvetica, Arial, sans-serif; font-size:15px; text-align:center;" href="' + nomination.reviewLink + '" target="_blank"><strong>Click here &raquo;</strong></a> to accept or decline nomination.</td>' +
    '</tr>' +
    '</table>' +
    '<p>Should you require assistance, please email: <a href="mailto:ThinkTank@multichoice.co.za">ThinkTank@multichoice.co.za</a>' +
    '</p>' +
    '<p>#weseeyou</p>' +
    '</td>' +
    '</tr>' +
    '<tr>' +
    '<td colspan="2">' +
    '<hr>' +
    '</td>' +
    '</tr>' +
    '<tr>' +
    '<td><img src="https://thinktankapi.multichoice.com/wp-content/uploads/2018/12/Logo-footer.png" width="400" height="33" alt="Logo compilation"/></td>' +
    '<td align="right" style="color:#999; font-size:11px; font-family:Arial, Helvetica, sans-serif">' +
    '<p>Copyright © MultiChoice<br>' +
    'All rights reserved</p>' +
    '</td>' +
    '</tr>' +
    '</table>' +
    '</body>'
  },
  teamNominationBodyWithReview: function (nomination) {
    return '<body leftmargin="0" topmargin="0" marginwidth="0" marginheight="0">' +
    '<table width="100%" border="0" align="left" cellpadding="10" cellspacing="0">' +
    '<tr>' +
    '<td id align="center" style="text-align: center; color: #FFF; text-transform:uppercase; font-family:Gotham, \'Helvetica Neue\', Helvetica, Arial, sans-serif" bgcolor="#00508F">' +
    '<h2>REVIEW YOUR NOMINATION</h2></td>' +
    '</tr>' +
    '</table>' +
    '<table width="600" align="center">' +
    '<tr>' +
    '<td colspan="2">&nbsp;</td>' +
    '</tr>' +
    '<tr>' +
    '<td colspan="2" valign="middle" style="text-align:center">&nbsp;</td>' +
    '</tr>' +
    '<tr>' +
    '<td colspan="2" style="font-family:Gotham, \'Helvetica Neue\', Helvetica, Arial, sans-serif">' +
    '<p>Dear ' + nomination.nominee + '</p>' +
    '<p>CONGRATULATIONS! </p>' +
    '<p>You’re part of the A-team and your contribution has been nominated for the Team award.</p>' +
    '<p>You must accept or decline the nomination. In the case you decline, please provide a valid reason for the decline, as this will affect the rest of the team.</p>' +
    '<p>Thank you for successful collaborative effort. </p>' +
    '<table bgcolor="#00508F" width="250" align="center" cellpadding="15" cellspacing="0">' +
    '<tr>' +
    '<td style="color:#EEE; text-decoration:none; font-family:\'Helvetica Neue\', Helvetica, Arial, sans-serif; font-size:16px; text-align:center" align="center">' +
    '<a style="color:#EEE; text-decoration:none; font-family:\'Helvetica Neue\', Helvetica, Arial, sans-serif; font-size:15px; text-align:center;" href="' + nomination.reviewLink + '" target="_blank"><strong>Click here &raquo;</strong></a> to accept or decline nomination.</td>' +
    '</tr>' +
    '</table>' +
    '<p>Should you require assistance, please email: <a href="mailto:ThinkTank@multichoice.co.za">ThinkTank@multichoice.co.za</a>' +
    '</p>' +
    '<p>#weseeyou</p>' +
    '</td>' +
    '</tr>' +
    '<tr>' +
    '<td colspan="2">' +
    '<hr>' +
    '</td>' +
    '</tr>' +
    '<tr>' +
    '<td><img src="https://thinktankapi.multichoice.com/wp-content/uploads/2018/12/Logo-footer.png" width="400" height="33" alt="Logo compilation"/></td>' +
    '<td align="right" style="color:#999; font-size:11px; font-family:Arial, Helvetica, sans-serif">' +
    '<p>Copyright © MultiChoice<br>' +
    'All rights reserved</p>' +
    '</td>' +
    '</tr>' +
    '</table>' +
    '</body>'
  },
  nomineeConfirmation: function (nomination) {
    return '<body leftmargin="0" topmargin="0" marginwidth="0" marginheight="0">' +
    '<table width="100%" border="0" align="left" cellpadding="10" cellspacing="0">' +
    '<tr>' +
    '<td id align="center" style="text-align: center; color: #FFF; text-transform:uppercase; font-family:Gotham, \'Helvetica Neue\', Helvetica, Arial, sans-serif" bgcolor="#00508F">' +
    '<h2>' + nomination.awardName + ' AWARD CONFIRMATION</h2></td>' +
    '</tr>' +
    '</table>' +
    '<table width="600" align="center">' +
    '<tr>' +
    '<td colspan="2">&nbsp;</td>' +
    '</tr>' +
    '<tr>' +
    '<td colspan="2" style="font-family:Gotham, \'Helvetica Neue\', Helvetica, Arial, sans-serif">' +
    '<p>Dear ' + nomination.nominee + '</p>' +
    '<p>You’ve been amazing! </p>' +
    '<p>And that is why you’ve been nominated for <strong>' + nomination.awardName + '</strong>.</p>' +
    '<p style="color: #00508F;">Congratulations, your award will be paid with your next salary (subject to payroll <br>' +
    'deadlines). Please contact your HCBP for further assistance.</p>' +
    '<p>Thank you, we value the difference you make.</p>' +
    '<table bgcolor="#00508F" width="250" align="center" cellpadding="15" cellspacing="0">' +
    '<tr>' +
    '<td style="color:#EEE; text-decoration:none; font-family:\'Helvetica Neue\', Helvetica, Arial, sans-serif; font-size:16px; text-align:center" align="center">' +
    '<a style="color:#EEE; text-decoration:none; font-family:\'Helvetica Neue\', Helvetica, Arial, sans-serif; font-size:15px; text-align:center;" href="' + nomination.reviewLink + '" target="_blank"><strong>Click here &raquo;</strong></a> to read your nomination.</td>' +
    '</tr>' +
    '</table>' +
    '<p>Should you require assistance, please email: <a href="mailto:ThinkTank@multichoice.co.za">ThinkTank@multichoice.co.za</a>' +
    '</p>' +
    '<p>#weseeyou</p>' +
    '</td>' +
    '</tr>' +
    '<tr>' +
    '<td colspan="2">' +
    '<hr>' +
    '</td>' +
    '</tr>' +
    '<tr>' +
    '<td><img src="https://thinktankapi.multichoice.com/wp-content/uploads/2018/12/Logo-footer.png" width="400" height="33" alt="Logo compilation"/></td>' +
    '<td align="right" style="color:#999; font-size:11px; font-family:Arial, Helvetica, sans-serif">' +
    '<p>Copyright © MultiChoice<br>' +
    'All rights reserved</p>' +
    '</td>' +
    '</tr>' +
    '</table>' +
    '</body>'
  },
  nominatorConfirmation: function (nomination) {
    return '<body leftmargin="0" topmargin="0" marginwidth="0" marginheight="0">' +
    '<table width="100%" border="0" align="left" cellpadding="10" cellspacing="0">' +
    '<tr>' +
    '<td id align="center" style="text-align: center; color: #FFF; text-transform:uppercase; font-family:Gotham, \'Helvetica Neue\', Helvetica, Arial, sans-serif" bgcolor="#00508F">' +
    '<h2>' + nomination.awardName + ' AWARD NOMINATION</h2></td>' +
    '</tr>' +
    '</table>' +
    '<table width="600" align="center">' +
    '<tr>' +
    '<td colspan="2">&nbsp;</td>' +
    '</tr>' +
    '<tr>' +
    '<td colspan="2" style="font-family:Gotham, \'Helvetica Neue\', Helvetica, Arial, sans-serif">' +
    '<p>Dear ' + nomination.nominee + '</p>' +
    '<p>Thank you for using #weseeyou to recognise your colleagues. </p>' +
    '<p>To keep you posted, the <strong>' + nomination.awardName + '</strong> nomination you submitted on the ' + nomination.submissionDate + ' has been approved by all and the nominees will be paid with the next possible salary run.</p>' +
    '<p>Thank you, we value the difference you make.</p>' +
    '<table bgcolor="#00508F" width="250" align="center" cellpadding="15" cellspacing="0">' +
    '<tr>' +
    '<td style="color:#EEE; text-decoration:none; font-family:\'Helvetica Neue\', Helvetica, Arial, sans-serif; font-size:16px; text-align:center" align="center">' +
    '<a style="color:#EEE; text-decoration:none; font-family:\'Helvetica Neue\', Helvetica, Arial, sans-serif; font-size:15px; text-align:center;" href="' + nomination.reviewLink + '" target="_blank"><strong>Click here &raquo;</strong></a> to read your nomination.</td>' +
    '</tr>' +
    '</table>' +
    '<p>Should you require assistance, please email: <a href="mailto:ThinkTank@multichoice.co.za">ThinkTank@multichoice.co.za</a>' +
    '</p>' +
    '<p>#weseeyou</p>' +
    '</td>' +
    '</tr>' +
    '<tr>' +
    '<td colspan="2">' +
    '<hr>' +
    '</td>' +
    '</tr>' +
    '<tr>' +
    '<td><img src="https://thinktankapi.multichoice.com/wp-content/uploads/2018/12/Logo-footer.png" width="400" height="33" alt="Logo compilation"/></td>' +
    '<td align="right" style="color:#999; font-size:11px; font-family:Arial, Helvetica, sans-serif">' +
    '<p>Copyright © MultiChoice<br>' +
    'All rights reserved</p>' +
    '</td>' +
    '</tr>' +
    '</table>' +
    '</body>'
  },
  teamNominationBodyWithReview: function (nomination) {
    return '<body leftmargin="0" topmargin="0" marginwidth="0" marginheight="0">' +
    '<table width="100%" border="0" align="left" cellpadding="10" cellspacing="0">' +
    '<tr>' +
    '<td id align="center" style="text-align: center; color: #FFF; text-transform:uppercase; font-family:Gotham, \'Helvetica Neue\', Helvetica, Arial, sans-serif" bgcolor="#00508F">' +
    '<h2>REVIEW YOUR NOMINATION</h2></td>' +
    '</tr>' +
    '</table>' +
    '<table width="600" align="center">' +
    '<tr>' +
    '<td colspan="2">&nbsp;</td>' +
    '</tr>' +
    '<tr>' +
    '<td colspan="2" style="font-family:Gotham, \'Helvetica Neue\', Helvetica, Arial, sans-serif">' +
    '<p>Dear ' + nomination.nominee + '</p>' +
    '<p>CONGRATULATIONS! </p>' +
    '<p>You’re part of the A-team and your contribution has been nominated for the Team award.</p>' +
    '<p>You must accept or decline the nomination. In the case you decline, please provide a valid reason for the decline, as this will affect the rest of the team.</p>' +
    '<p>Thank you for successful collaborative effort. </p>' +
    '<table bgcolor="#00508F" width="250" align="center" cellpadding="15" cellspacing="0">' +
    '<tr>' +
    '<td style="color:#EEE; text-decoration:none; font-family:\'Helvetica Neue\', Helvetica, Arial, sans-serif; font-size:16px; text-align:center" align="center">' +
    '<a style="color:#EEE; text-decoration:none; font-family:\'Helvetica Neue\', Helvetica, Arial, sans-serif; font-size:15px; text-align:center;" href="' + nomination.reviewLink + '" target="_blank"><strong>Click here &raquo;</strong></a> to accept or decline nomination.</td>' +
    '</tr>' +
    '</table>' +
    '<p>The nomination process closes: ' + nomination.closingDate + '<br>' +
    'Should you require assistance, please email: <a href="mailto:ThinkTank@multichoice.co.za">ThinkTank@multichoice.co.za</a>' +
    '</p>' +
    '<p>#weseeyou</p>' +
    '</td>' +
    '</tr>' +
    '<tr>' +
    '<td colspan="2">' +
    '<hr>' +
    '</td>' +
    '</tr>' +
    '<tr>' +
    '<td><img src="https://thinktankapi.multichoice.com/wp-content/uploads/2018/12/Logo-footer.png" width="400" height="33" alt="Logo compilation"/></td>' +
    '<td align="right" style="color:#999; font-size:11px; font-family:Arial, Helvetica, sans-serif">' +
    '<p>Copyright © MultiChoice<br>' +
    'All rights reserved</p>' +
    '</td>' +
    '</tr>' +
    '</table>' +
    '</body>'
  },
  nominatorRejectionConfirmation: function (nomination) {
    return '<body leftmargin="0" topmargin="0" marginwidth="0" marginheight="0">' +
    '<table width="100%" border="0" align="left" cellpadding="10" cellspacing="0">' +
    '<tr>' +
    '<td id align="center" style="text-align: center; color: #FFF; text-transform:uppercase; font-family:Gotham, \'Helvetica Neue\', Helvetica, Arial, sans-serif" bgcolor="#00508F">' +
    '<h2>' + nomination.awardName + ' AWARD NOMINATION</h2></td>' +
    '</tr>' +
    '</table>' +
    '<table width="600" align="center">' +
    '<tr>' +
    '<td colspan="2">&nbsp;</td>' +
    '</tr>' +
    '<tr>' +
    '<td colspan="2" style="font-family:Gotham, \'Helvetica Neue\', Helvetica, Arial, sans-serif">' +
    '<p>Dear ' + nomination.nominee + '</p>' +
    '<p>Thank you for using #weseeyou to recognise your colleagues. </p>' +
    '<p>To keep you posted, the <strong>' + nomination.awardName + '</strong> nomination you submitted on the ' + nomination.submissionDate + ' has been rejected. Please contact your HCBP for further details.</p>' +
    '<p>Thank you, we value the difference you make.</p>' +
    '<p>Should you require assistance, please email: <a href="mailto:ThinkTank@multichoice.co.za">ThinkTank@multichoice.co.za</a>' +
    '</p>' +
    '<p>#weseeyou</p>' +
    '</td>' +
    '</tr>' +
    '<tr>' +
    '<td colspan="2">' +
    '<hr>' +
    '</td>' +
    '</tr>' +
    '<tr>' +
    '<td><img src="' + this.footerImage + '" width="400" height="33" alt="Logo compilation"/></td>' +
    '<td align="right" style="color:#999; font-size:11px; font-family:Arial, Helvetica, sans-serif">' +
    '<p>Copyright © MultiChoice<br>' +
    'All rights reserved</p>' +
    '</td>' +
    '</tr>' +
    '</table>' +
    '</body>'
  },
  nominationBodyProjectSponsorWithReview: function (nomination) {
    return '<body leftmargin="0" topmargin="0" marginwidth="0" marginheight="0">' +
    '<table width="100%" border="0" align="left" cellpadding="10" cellspacing="0">' +
    '<tr>' +
    '<td id align="center" style="text-align: center; color: #FFF; text-transform:uppercase; font-family:Gotham, \'Helvetica Neue\', Helvetica, Arial, sans-serif" bgcolor="#00508F">' +
    '<h3>PLEASE REVIEW A NOMINATION FOR ONE OF YOUR TEAM MEMBERS</h3></td>' +
    '</tr>' +
    '</table>' +
    '<table width="600" align="center">' +
    '<tr>' +
    '<td colspan="2">&nbsp;</td>' +
    '</tr>' +
    '<tr>' +
    '<td colspan="2" valign="middle" style="text-align:center">&nbsp;</td>' +
    '</tr>' +
    '<tr>' +
    '<td colspan="2" style="font-family:Gotham, \'Helvetica Neue\', Helvetica, Arial, sans-serif">' +
    '<p>We’ve captured another WOW! moment, which just makes our day.</p>' +
    '<p>As ' + nomination.position + ' approver you need to review the nomination on Think Tank.</p>' +
    '<table bgcolor="#00508F" width="250" align="center" cellpadding="15" cellspacing="0">' +
    '<tr>' +
    '<td style="color:#EEE; text-decoration:none; font-family:\'Helvetica Neue\', Helvetica, Arial, sans-serif; font-size:16px; text-align:center" align="center">' +
    '<a style="color:#EEE; text-decoration:none; font-family:\'Helvetica Neue\', Helvetica, Arial, sans-serif; font-size:15px; text-align:center;" href="' + nomination.reviewLink + '" target="_blank"><strong><u>Click here</u></strong></a></td>' +
    '</tr>' +
    '</table>' +
    '<p>Should you require assistance, please email: <a href="mailto:ThinkTank@multichoice.co.za">ThinkTank@multichoice.co.za</a>' +
    '</p>' +
    '<p>Thank you,<br>' +
    'for #seeing others, as #weseeyou.</p>' +
    '</td>' +
    '</tr>' +
    '<tr>' +
    '<td colspan="2">' +
    '<hr>' +
    '</td>' +
    '</tr>' +
    '<tr>' +
    '<td><img src="https://thinktankapi.multichoice.com/wp-content/uploads/2018/12/Logo-footer.png" width="400" height="33" alt="Logo compilation"/></td>' +
    '<td align="right" style="color:#999; font-size:11px; font-family:Arial, Helvetica, sans-serif">' +
    '<p>Copyright © MultiChoice<br>' +
    'All rights reserved</p>' +
    '</td>' +
    '</tr>' +
    '</table>' +
    '</body>'
  },
  workflowNotificationForRejection: function (nomination) {
    return '<body leftmargin="0" topmargin="0" marginwidth="0" marginheight="0">' +
    '<table width="100%" border="0" align="left" cellpadding="10" cellspacing="0">' +
    '<tr>' +
    '<td id align="center" style="text-align: center; color: #FFF; text-transform:uppercase; font-family:Gotham, \'Helvetica Neue\', Helvetica, Arial, sans-serif" bgcolor="#00508F">' +
    '<h2>UPDATE ON NOMINATION STATUS</h2></td>' +
    '</tr>' +
    '</table>' +
    '<table width="600" align="center">' +
    '<tr>' +
    '<td colspan="2">&nbsp;</td>' +
    '</tr>' +
    '<tr>' +
    '<td colspan="2" style="font-family:Gotham, \'Helvetica Neue\', Helvetica, Arial, sans-serif">' +
    '<p>To keep you posted, the nomination you approved for nominee ' + nomination.nominee + ' has been rejected by ' + nomination.level + ' on ThinkTank. Please contact your HRBP for further details.</p>' +
    '<p>Should you require assistance, please email: <a href="mailto:ThinkTank@multichoice.co.za">ThinkTank@multichoice.co.za</a>' +
    '</p>' +
    '<p>Thank you,<br>' +
    'for #seeing others, as #weseeyou.</p>' +
    '</td>' +
    '</tr>' +
    '<tr>' +
    '<td colspan="2">' +
    '<hr>' +
    '</td>' +
    '</tr>' +
    '<tr>' +
    '<td><img src="' + this.footerImage + '" width="400" height="33" alt="Logo compilation"/></td>' +
    '<td align="right" style="color:#999; font-size:11px; font-family:Arial, Helvetica, sans-serif">' +
    '<p>Copyright © MultiChoice<br>' +
    'All rights reserved</p>' +
    '</td>' +
    '</tr>' +
    '</table>' +
    '</body>'
  },
  high5Notification: function (nomination) {
    return '<body leftmargin="0" topmargin="0" marginwidth="0" marginheight="0">' +
    '<table width="100%" border="0" align="left" cellpadding="10" cellspacing="0">' +
    '<tr>' +
    '<td id align="center" style="text-align: center; color: #FFF; text-transform:uppercase; font-family:Gotham, \'Helvetica Neue\', Helvetica, Arial, sans-serif" bgcolor="#00508F">' +
    '<h2>HIGH5 NOMINATION</h2></td>' +
    '</tr>' +
    '</table>' +
    '<table width="600" align="center">' +
    '<tr>' +
    '<td colspan="2">&nbsp;</td>' +
    '</tr>' +
    '<tr>' +
    '<td colspan="2" style="font-family:Gotham, \'Helvetica Neue\', Helvetica, Arial, sans-serif">' +
    '<p>Dear ' + nomination.nominee + '</p>' +
    '<p><strong> CONGRATULATIONS! </strong></p>' +
    '<p>You’ve been High 5’ed by <strong>' + nomination.nominator + '</strong> for living the MultiChoice Way.</p>' +
    '<p>The MultiChoice Way Behaviour selected is – ' + nomination.cardName + '. </p>' +
    '<p>Open the attachment to view your High 5 ecard message. </p>' +
    '<p>Thanks for going above and beyond.</p>' +
    '<br/> <p>Should you require assistance, please email: <a href="mailto:ThinkTank@multichoice.co.za">ThinkTank@multichoice.co.za</a>' +
    '</p>' +
    '</td>' +
    '</tr>' +
    '<tr>' +
    '<td colspan="2">' +
    '<hr>' +
    '</td>' +
    '</tr>' +
    '<tr>' +
    '<td><img src="' + this.footerImage + '" width="400" height="33" alt="Logo compilation"/></td>' +
    '<td align="right" style="color:#999; font-size:11px; font-family:Arial, Helvetica, sans-serif">' +
    '<p>Copyright © MultiChoice<br>' +
    'All rights reserved</p>' +
    '</td>' +
    '</tr>' +
    '</table>' +
    '</body>'
  },
  downgradeNotification: function (nomination) {
    console.log(' nomination.motivationMessage ', nomination.motivationMessage, nomination.nomination_category)
    if (nomination.category === 'On the Spot') {
      var name = nomination.nominator
    } else if (nomination.nomination_category === 'Teams') {
      var name = nomination.nominator+' & Project Sponsor'
    }
    console.log('name ', name)
    return '<body leftmargin="0" topmargin="0" marginwidth="0" marginheight="0">' +
    '<table width="100%" border="0" align="left" cellpadding="10" cellspacing="0">' +
    '<tr>' +
    '<td id align="center" style="text-align: center; color: #FFF; text-transform:uppercase; font-family:Gotham, \'Helvetica Neue\', Helvetica, Arial, sans-serif" bgcolor="#00508F">' +
    '<h2>HIGH5 NOMINATION</h2></td>' +
    '</tr>' +
    '</table>' +
    '<table width="600" align="center">' +
    '<tr>' +
    '<td colspan="2">&nbsp;</td>' +
    '</tr>' +
    '<tr>' +
    '<td colspan="2" style="font-family:Gotham, \'Helvetica Neue\', Helvetica, Arial, sans-serif">' +
    '<p>Dear ' + nomination.nominator + '</p>' +
    '<p>Your '+nomination.category+' nomination for '+ nomination.nominee +' was downgraded to a High 5 nomination.</p>' +
    '<p>The reason for the downgrade is as follows:</p>' +
    '<p> '+ nomination.rejectionReason +' </p>' +
    '<p>Open the attachment to view the High 5 ecard message. </p>' +
    '<br/> <p>Should you require assistance, please email: <a href="mailto:ThinkTank@multichoice.co.za">ThinkTank@multichoice.co.za</a>' +
    '</p>' +
    '</td>' +
    '</tr>' +
    '<tr>' +
    '<td colspan="2">' +
    '<hr>' +
    '</td>' +
    '</tr>' +
    '<tr>' +
    '<td><img src="' + this.footerImage + '" width="400" height="33" alt="Logo compilation"/></td>' +
    '<td align="right" style="color:#999; font-size:11px; font-family:Arial, Helvetica, sans-serif">' +
    '<p>Copyright © MultiChoice<br>' +
    'All rights reserved</p>' +
    '</td>' +
    '</tr>' +
    '</table>' +
    '</body>'
  },
  onTheSpotNotification: function (nomination) {
    console.log(' 517 nomination ', nomination)
    return '<body leftmargin="0" topmargin="0" marginwidth="0" marginheight="0">' +
    '<table width="100%" border="0" align="left" cellpadding="10" cellspacing="0">' +
    '<tr>' +
    '<td id align="center" style="text-align: center; color: #FFF; text-transform:uppercase; font-family:Gotham, \'Helvetica Neue\', Helvetica, Arial, sans-serif" bgcolor="#00508F">' +
    '<h2>On The Spot NOMINATION</h2></td>' +
    '</tr>' +
    '</table>' +
    '<table width="600" align="center">' +
    '<tr>' +
    '<td colspan="2">&nbsp;</td>' +
    '</tr>' +
    '<tr>' +
    '<td colspan="2" style="font-family:Gotham, \'Helvetica Neue\', Helvetica, Arial, sans-serif">' +
    '<p>Dear ' + nomination.nominator + '</p>' +
    '<p><strong> CONGRATULATIONS! </strong></p>' +
    '<p>Thank you for On The Spot Nomination. You have nominated <strong>' + nomination.nominee + '</strong> for living the MultiChoice Way.</p>' +
    '<p>The MultiChoice Way Behaviour selected is – ' + nomination.nominationData + '. </p>' +
    '<br/> <p>Should you require assistance, please email: <a href="mailto:ThinkTank@multichoice.co.za">ThinkTank@multichoice.co.za</a>' +
    '</p>' +
    '</td>' +
    '</tr>' +
    '<tr>' +
    '<td colspan="2">' +
    '<hr>' +
    '</td>' +
    '</tr>' +
    '<tr>' +
    '<td><img src="' + this.footerImage + '" width="400" height="33" alt="Logo compilation"/></td>' +
    '<td align="right" style="color:#999; font-size:11px; font-family:Arial, Helvetica, sans-serif">' +
    '<p>Copyright © MultiChoice<br>' +
    'All rights reserved</p>' +
    '</td>' +
    '</tr>' +
    '</table>' +
    '</body>'
  },
  equitynominationBodyforNominee: function (nomination) {
    return '<body leftmargin="0" topmargin="0" marginwidth="0" marginheight="0">' +
    '<table width="100%" border="0" align="left" cellpadding="10" cellspacing="0">' +
    '<tr>' +
    '<td id align="center" style="text-align: center; color: #FFF; text-transform:uppercase; font-family:Gotham, \'Helvetica Neue\', Helvetica, Arial, sans-serif" bgcolor="#00508F">' +
    '<h2>YOUR NOMINATION AS EMPLOYMENT EQUITY FORUM REPRESENTATIVE</h2></td>' +
    '</tr>' +
    '</table>' +
    '<table width="600" align="center">' +
    '<tr>' +
    '<td colspan="2">&nbsp;</td>' +
    '</tr>' +
    '<tr>' +
    '<td colspan="2" style="font-family:Gotham, \'Helvetica Neue\', Helvetica, Arial, sans-serif">' +
    '<p>You have been nominated to stand to be elected as an Employment Equity Forum Representative for which you need to approve your nomination for your name to form part of the voting process.  All elected Employment Equity Forum representatives will be trained to ensure that they can constructively fulfil their role.</p>' +
    '<p>Please note with your acceptance of the nomination:</p>' +
    '<ul>' +
    '<li>You provide your consent for your gender and race to be published on the voting system to ensure that our forums are representative of our workforce;</li>' +
    '<li>You understand the roles and responsibilities that you will be tasked with, should you be elected as an Employment Equity Forum representative.</li>' +
    '</ul>' +
    '<p>In the event that you decline, your name will not form part of the nominee list during the voting process. </p>' +
    '<table bgcolor="#00508F" width="250" align="center" cellpadding="15" cellspacing="0">' +
    '<tr>' +
    '<td style="color:#EEE; text-decoration:none; font-family:\'Helvetica Neue\', Helvetica, Arial, sans-serif; font-size:16px; text-align:center" align="center">' +
    '<a style="color:#EEE; text-decoration:none; font-family:\'Helvetica Neue\', Helvetica, Arial, sans-serif; font-size:15px; text-align:center;" href="' + nomination.reviewLink + '" target="_blank"><strong>Click here &raquo;</strong></a> to accept or decline nomination.</td>' +
    '</tr>' +
    '</table>' +    
    '<br/> <p>Should you have any questions, please contact your relevant Human Resources Business Partner.</p>' +
    '</td>' +
    '</tr>' +
    '<tr>' +
    '<td colspan="2">' +
    '<hr>' +
    '</td>' +
    '</tr>' +
    '<tr>' +
    '<td><img src="' + this.footerImage + '" width="400" height="33" alt="Logo compilation"/></td>' +
    '<td align="right" style="color:#999; font-size:11px; font-family:Arial, Helvetica, sans-serif">' +
    '<p>Copyright © MultiChoice<br>' +
    'All rights reserved</p>' +
    '</td>' +
    '</tr>' +
    '</table>' +
    '</body>'
  },
  // Below template is used in Employee of Month/Team Exco2 notification to approve/reject
  nominationBodyForEmployeeAwardNotification: function (nomination) {
    return '<body leftmargin="0" topmargin="0" marginwidth="0" marginheight="0">' +
    '<table width="100%" border="0" align="left" cellpadding="10" cellspacing="0">' +
    '<tr>' +
    '<td id align="center" style="text-align: center; color: #FFF; text-transform:uppercase; font-family:Gotham, \'Helvetica Neue\', Helvetica, Arial, sans-serif" bgcolor="#00508F">' +
    '<h3>PLEASE REVIEW '+ nomination.nominationType +' NOMINATION FOR YOUR TEAM MEMBERS</h3></td>' +
    '</tr>' +
    '</table>' +
    '<table width="600" align="center">' +
    '<tr>' +
    '<td colspan="2">&nbsp;</td>' +
    '</tr>' +
    '<tr>' +
    '<td colspan="2" valign="middle" style="text-align:center">&nbsp;</td>' +
    '</tr>' +
    '<tr>' +
    '<td colspan="2" style="font-family:Gotham, \'Helvetica Neue\', Helvetica, Arial, sans-serif">' +
    '<p>We’ve captured another WOW! moment, which just makes our day.</p>' +
    '<p>As ' + nomination.position + ' approver you need to review the nomination on Think Tank.</p>' +
    '<table bgcolor="#00508F" width="250" align="center" cellpadding="15" cellspacing="0">' +
    '<tr>' +
    '<td style="color:#EEE; text-decoration:none; font-family:\'Helvetica Neue\', Helvetica, Arial, sans-serif; font-size:16px; text-align:center" align="center">' +
    '<a style="color:#EEE; text-decoration:none; font-family:\'Helvetica Neue\', Helvetica, Arial, sans-serif; font-size:15px; text-align:center;" href="' + nomination.reviewLink + '" target="_blank"><strong><u>Click here</u></strong></a></td>' +
    '</tr>' +
    '</table>' +
    '<p>Should you require assistance, please email: <a href="mailto:ThinkTank@multichoice.co.za">ThinkTank@multichoice.co.za</a>' +
    '</p>' +
    '<p>Thank you,<br>' +
    'for #seeing others, as #weseeyou.</p>' +
    '</td>' +
    '</tr>' +
    '<tr>' +
    '<td colspan="2">' +
    '<hr>' +
    '</td>' +
    '</tr>' +
    '<tr>' +
    '<td><img src="https://thinktankapi.multichoice.com/wp-content/uploads/2018/12/Logo-footer.png" width="400" height="33" alt="Logo compilation"/></td>' +
    '<td align="right" style="color:#999; font-size:11px; font-family:Arial, Helvetica, sans-serif">' +
    '<p>Copyright © MultiChoice<br>' +
    'All rights reserved</p>' +
    '</td>' +
    '</tr>' +
    '</table>' +
    '</body>'
  },
  nomineeConfirmationEmployeeAward: function (nomination) {
    return '<body leftmargin="0" topmargin="0" marginwidth="0" marginheight="0">' +
    '<table width="100%" border="0" align="left" cellpadding="10" cellspacing="0">' +
    '<tr>' +
    '<td id align="center" style="text-align: center; color: #FFF; text-transform:uppercase; font-family:Gotham, \'Helvetica Neue\', Helvetica, Arial, sans-serif" bgcolor="#00508F">' +
    '<h2>' + nomination.awardName + ' AWARD CONFIRMATION</h2></td>' +
    '</tr>' +
    '</table>' +
    '<table width="600" align="center">' +
    '<tr>' +
    '<td colspan="2">&nbsp;</td>' +
    '</tr>' +
    '<tr>' +
    '<td colspan="2" style="font-family:Gotham, \'Helvetica Neue\', Helvetica, Arial, sans-serif">' +
    '<p>CONGRATULATIONS </p>' +
    '<p>You’ve been selected as the ' + nomination.awardName + ' for your business area for living the Multichoice values, well done and thank you for your contribution and efforts, we really value the difference you make.</p><br>' +
    '<p> Your award will be paid with your next salary (subject to payroll deadlines). <br>' +
    '<table bgcolor="#00508F" width="250" align="center" cellpadding="15" cellspacing="0">' +
    '<tr>' +
    '<td style="color:#EEE; text-decoration:none; font-family:\'Helvetica Neue\', Helvetica, Arial, sans-serif; font-size:16px; text-align:center" align="center">' +
    '<a style="color:#EEE; text-decoration:none; font-family:\'Helvetica Neue\', Helvetica, Arial, sans-serif; font-size:15px; text-align:center;" href="' + nomination.reviewLink + '" target="_blank"><strong>Click here &raquo;</strong></a> to read your nomination.</td>' +
    '</tr>' +
    '</table>' +
    '<p>Should you require assistance, please email: <a href="mailto:ThinkTank@multichoice.co.za">ThinkTank@multichoice.co.za</a>' +
    '</p>' +
    '<p>#weseeyou</p>' +
    '</td>' +
    '</tr>' +
    '<tr>' +
    '<td colspan="2">' +
    '<hr>' +
    '</td>' +
    '</tr>' +
    '<tr>' +
    '<td><img src="https://thinktankapi.multichoice.com/wp-content/uploads/2018/12/Logo-footer.png" width="400" height="33" alt="Logo compilation"/></td>' +
    '<td align="right" style="color:#999; font-size:11px; font-family:Arial, Helvetica, sans-serif">' +
    '<p>Copyright © MultiChoice<br>' +
    'All rights reserved</p>' +
    '</td>' +
    '</tr>' +
    '</table>' +
    '</body>'
  },
  nominatorRejectionConfirmationForEmployeeAward: function (nomination) {
    return '<body leftmargin="0" topmargin="0" marginwidth="0" marginheight="0">' +
    '<table width="100%" border="0" align="left" cellpadding="10" cellspacing="0">' +
    '<tr>' +
    '<td id align="center" style="text-align: center; color: #FFF; text-transform:uppercase; font-family:Gotham, \'Helvetica Neue\', Helvetica, Arial, sans-serif" bgcolor="#00508F">' +
    '<h2>' + nomination.awardName + ' AWARD NOMINATION</h2></td>' +
    '</tr>' +
    '</table>' +
    '<table width="600" align="center">' +
    '<tr>' +
    '<td colspan="2">&nbsp;</td>' +
    '</tr>' +
    '<tr>' +
    '<td colspan="2" style="font-family:Gotham, \'Helvetica Neue\', Helvetica, Arial, sans-serif">' +
    '<p>Dear ' + nomination.nominee + '</p>' +
    '<p>Thank you for using #weseeyou to recognise your colleagues. </p>' +
    '<p>To keep you posted, the <strong>' + nomination.awardName + '</strong> nomination you submitted on the ' + nomination.submissionDate + ' has been rejected. Please contact your HCBP for further details.</p>' +
    '<p>Thank you, we value the difference you make.</p>' +
    '<p>Should you require assistance, please email: <a href="mailto:ThinkTank@multichoice.co.za">ThinkTank@multichoice.co.za</a>' +
    '</p>' +
    '<p>#weseeyou</p>' +
    '</td>' +
    '</tr>' +
    '<tr>' +
    '<td colspan="2">' +
    '<hr>' +
    '</td>' +
    '</tr>' +
    '<tr>' +
    '<td><img src="' + this.footerImage + '" width="400" height="33" alt="Logo compilation"/></td>' +
    '<td align="right" style="color:#999; font-size:11px; font-family:Arial, Helvetica, sans-serif">' +
    '<p>Copyright © MultiChoice<br>' +
    'All rights reserved</p>' +
    '</td>' +
    '</tr>' +
    '</table>' +
    '</body>'
  },
  nominatorConfirmationForEmployeeAward: function (nomination) {
    return '<body leftmargin="0" topmargin="0" marginwidth="0" marginheight="0">' +
    '<table width="100%" border="0" align="left" cellpadding="10" cellspacing="0">' +
    '<tr>' +
    '<td id align="center" style="text-align: center; color: #FFF; text-transform:uppercase; font-family:Gotham, \'Helvetica Neue\', Helvetica, Arial, sans-serif" bgcolor="#00508F">' +
    '<h2>' + nomination.awardName + ' AWARD NOMINATION</h2></td>' +
    '</tr>' +
    '</table>' +
    '<table width="600" align="center">' +
    '<tr>' +
    '<td colspan="2">&nbsp;</td>' +
    '</tr>' +
    '<tr>' +
    '<td colspan="2" style="font-family:Gotham, \'Helvetica Neue\', Helvetica, Arial, sans-serif">' +
    '<p>Dear ' + nomination.nominee + '</p>' +
    '<p>Thank you for using #weseeyou to recognise your colleagues. </p>' +
    '<p>To keep you posted, the <strong>' + nomination.awardName + '</strong> nomination you submitted on the ' + nomination.submissionDate + ' has been approved by the Exco-2 and the employees award will be paid with their next salary (subject to payroll deadlines).</p>' +
    '<table bgcolor="#00508F" width="250" align="center" cellpadding="15" cellspacing="0">' +
    '<tr>' +
    '<td style="color:#EEE; text-decoration:none; font-family:\'Helvetica Neue\', Helvetica, Arial, sans-serif; font-size:16px; text-align:center" align="center">' +
    '<a style="color:#EEE; text-decoration:none; font-family:\'Helvetica Neue\', Helvetica, Arial, sans-serif; font-size:15px; text-align:center;" href="' + nomination.reviewLink + '" target="_blank"><strong>Click here &raquo;</strong></a> to read your nomination.</td>' +
    '</tr>' +
    '</table>' +
    '<p>Should you require assistance, please email: <a href="mailto:ThinkTank@multichoice.co.za">ThinkTank@multichoice.co.za</a>' +
    '</p>' +
    '<p>#weseeyou</p>' +
    '</td>' +
    '</tr>' +
    '<tr>' +
    '<td colspan="2">' +
    '<hr>' +
    '</td>' +
    '</tr>' +
    '<tr>' +
    '<td><img src="https://thinktankapi.multichoice.com/wp-content/uploads/2018/12/Logo-footer.png" width="400" height="33" alt="Logo compilation"/></td>' +
    '<td align="right" style="color:#999; font-size:11px; font-family:Arial, Helvetica, sans-serif">' +
    '<p>Copyright © MultiChoice<br>' +
    'All rights reserved</p>' +
    '</td>' +
    '</tr>' +
    '</table>' +
    '</body>'
  },
  workflowNotificationForRejectionForEmployeeAward: function (nomination) {
    return '<body leftmargin="0" topmargin="0" marginwidth="0" marginheight="0">' +
    '<table width="100%" border="0" align="left" cellpadding="10" cellspacing="0">' +
    '<tr>' +
    '<td id align="center" style="text-align: center; color: #FFF; text-transform:uppercase; font-family:Gotham, \'Helvetica Neue\', Helvetica, Arial, sans-serif" bgcolor="#00508F">' +
    '<h2>UPDATE ON NOMINATION STATUS</h2></td>' +
    '</tr>' +
    '</table>' +
    '<table width="600" align="center">' +
    '<tr>' +
    '<td colspan="2">&nbsp;</td>' +
    '</tr>' +
    '<tr>' +
    '<td colspan="2" style="font-family:Gotham, \'Helvetica Neue\', Helvetica, Arial, sans-serif">' +
    '<p>To keep you posted, the ' + nomination.awardName + ' nomination  you submitted on ' + nomination.submissionDate + ' has been rejected by the ' + nomination.level + ' on ThinkTank.</p>' +
    '<p>Should you require assistance, please email: <a href="mailto:ThinkTank@multichoice.co.za">ThinkTank@multichoice.co.za</a>' +
    '</p>' +
    '<p>Thank you,<br>' +
    'for #seeing others, as #weseeyou.</p>' +
    '</td>' +
    '</tr>' +
    '<tr>' +
    '<td colspan="2">' +
    '<hr>' +
    '</td>' +
    '</tr>' +
    '<tr>' +
    '<td><img src="' + this.footerImage + '" width="400" height="33" alt="Logo compilation"/></td>' +
    '<td align="right" style="color:#999; font-size:11px; font-family:Arial, Helvetica, sans-serif">' +
    '<p>Copyright © MultiChoice<br>' +
    'All rights reserved</p>' +
    '</td>' +
    '</tr>' +
    '</table>' +
    '</body>'
  },
  nomineeConfirmationEmployeeAwardtest: function (nomination) {
    return '<body leftmargin="0" topmargin="0" marginwidth="0" marginheight="0" style="margin-left:0; margin-right:0; margin-bottom:0; margin-top:0; padding-top:0;">' +
    '<table width="100%" border="0" align="left" cellspacing="0">' +
    '<tr>' +
    '<td align="center" text-align:center; color:#ffffff; text-transform:uppercase; font-family:Gotham, \'Helvetica Neue\', Helvetica, Arial, sans-serif" bgcolor="#00508F"><img src="http://thinktankapi-uat.multichoice.com/wp-content/uploads/Team-of-the-month.png"  width="100%" style="width:100%;"></td>' +
    '<!--td align="center" text-align:center; color:#ffffff; text-transform:uppercase; font-family:Gotham, \'Helvetica Neue\', Helvetica, Arial, sans-serif" bgcolor="#00508F"><img src="http://thinktankapi-uat.multichoice.com/wp-content/uploads/Employee-of-the-month.png" width="100%" style="width:100%;"></td-->' +
    '</tr>' +
    '</table><BR><BR>' +
    '<table width="800" align="center">' +
    '<tr>' +
    '<td align="center">' +
    '<hr style="height:5px; width:100%; background-color:#000000; border:none;"/>' +
    '<p><h2><B>Employee of the Month</B></h2></p>'+
    '<hr style="height:5px; width:100%; background-color:#000000; border:none;"/>' +
    '<p align="center"><strong>This certificate is proudly presented to</strong></p>' +
    '<p align="center" style="font-size:20px;">' + nomination.nominee + '</td>' +
    '<p align="center" style="font-size:20px;">' + nomination.company + '</td>' +
    '</tr>'+
    '<!--tr>' +
    '<td align="center"><p align="center" style="font-size:16px;"><strong>Why are you nominating this person?</strong></p></td>'+
    '</tr-->'+
    '<BR><tr>'+
    '<td align="center">'+nomination.reason+'</td>'+
    '</tr>' +
    '</table>' +
    '</body>'
  },
  confirmationOfBUEOYNominationBody: function (nomination) {
    return '<body leftmargin="0" topmargin="0" marginwidth="0" marginheight="0" style="" cz-shortcut-listen="true">' +
    '<table width="100%" border="0" align="left" cellpadding="10" cellspacing="0">' +
    '<tbody><tr><td id="" align="center" style="text-align: center; color: #FFF; text-transform:uppercase; font-family:Gotham, \'Helvetica Neue\', Helvetica, Arial, sans-serif" bgcolor="#00508F">' +
    '<h2>BU Employee of the Year Award Nomination</h2></td></tr></tbody></table><table width="600" align="center"><tbody><tr><td>&nbsp;</td></tr><tr>' +
    '<td valign="middle" style="text-align:center">&nbsp;</td>' +
    '</tr><tr><td style="font-family:Gotham, \'Helvetica Neue\', Helvetica, Arial, sans-serif">' +
    '<p>Dear ' + nomination.nominator + '</p>' +
    '<p>Thank you for submitting your BU Employee of the Year nominations as per below.<BR><BR><strong>' +
    nomination.winnerRunnerStatus + ' : ' + nomination.nominee  + '</strong></p>' +
    '<p>Use the link below to view the nomination:</p>' +
    '</td></tr><tr><td><BR>' +
    '<table bgcolor="#00508F" width="250" align="center" cellpadding="15" cellspacing="0">' +
    '<tr>' +
    '<td style="color:#EEE; text-decoration:none; font-family:\'Helvetica Neue\', Helvetica, Arial, sans-serif; font-size:16px; text-align:center" align="center">' +
    '<a style="color:#EEE; text-decoration:none; font-family:\'Helvetica Neue\', Helvetica, Arial, sans-serif; font-size:15px; text-align:center;" href="' + nomination.reviewLink + '" target="_blank"><strong><u>Click here</u></strong></a></td>' +
    '</tr>' +
    '</table><BR>' +
    '</td>' +
    '</tr><tr><td><hr>Thank you, we value the difference you make.<BR>Should you require assistance, please email: ThinkTank@multichoice.co.za</td></tr>' +
    '<tr><td><img src="https://thinktankapi.multichoice.com/wp-content/uploads/2018/12/Logo-footer.png" width="600" height="45" alt="Logo compilation"></td></tr><tr><td>&nbsp;</td></tr><tr>' +
    '<td align="center" style="color:#666; font-size:12px; text-align:center; font-family:Gotham, \'Helvetica Neue\', Helvetica, Arial, sans-serif">Copyright © MultiChoice. All rights reserved</td></tr></tbody></table></body>'
  },
  confirmationOfMCGEOYNominationBody: function (nomination) {
    return '<body leftmargin="0" topmargin="0" marginwidth="0" marginheight="0" style="" cz-shortcut-listen="true">' +
    '<table width="100%" border="0" align="left" cellpadding="10" cellspacing="0">' +
    '<tbody><tr><td id="" align="center" style="text-align: center; color: #FFF; text-transform:uppercase; font-family:Gotham, \'Helvetica Neue\', Helvetica, Arial, sans-serif" bgcolor="#00508F">' +
    '<h2>MCG Employee of the Year</h2></td></tr></tbody></table><table width="600" align="center"><tbody><tr><td>&nbsp;</td></tr><tr>' +
    '<td valign="middle" style="text-align:center">&nbsp;</td>' +
    '</tr><tr><td style="font-family:Gotham, \'Helvetica Neue\', Helvetica, Arial, sans-serif">' +
    '<p>Dear ' + nomination.nominator + '</p>' +
    '<p>Thank you for submitting your MCG Employee of the Year nomination as per below.</p></td></tr><tr><br>' +
    '<tr><td> Selection: <strong> '+ nomination.NominationTeamNames[0]['option'] + '</td></tr>' +
    '<tr><td><strong>'+ nomination.NominationTeamNames[0]['name'] + '</strong> from ' + nomination.NominationTeamNames[0]['country'] +'</td></tr>' +
    '<tr><td> Employee number: '+ nomination.NominationTeamNames[0]['employeeNum'] + '</td></tr>' +
    '<tr><td style="padding-bottom:15px;"> GOM: '+ nomination.NominationTeamNames[0]['GOM'] + '</td></tr><br>' +
    '<p></p>' +

    '<tr><td> Selection: <strong> '+ nomination.NominationTeamNames[1]['option'] + '</td></tr>' +
    '<tr><td><strong>'+ nomination.NominationTeamNames[1]['name'] + '</strong> from ' + nomination.NominationTeamNames[1]['country'] +'</td></tr>' +
    '<tr><td> Employee number: '+ nomination.NominationTeamNames[1]['employeeNum'] + '</td></tr>' +
    '<tr><td style="padding-bottom:15px;"> GOM: '+ nomination.NominationTeamNames[1]['GOM'] + '</td></tr><br>' +
    '<p></p>' +

    '<tr><td> Selection: <strong> '+ nomination.NominationTeamNames[2]['option'] + '</td></tr>' +
    '<tr><td><strong>'+ nomination.NominationTeamNames[2]['name'] + '</strong> from ' + nomination.NominationTeamNames[2]['country'] +'</td></tr>' +
    '<tr><td> Employee number: '+ nomination.NominationTeamNames[2]['employeeNum'] + '</td></tr>' +
    '<tr><td style="padding-bottom:15px;"> GOM: '+ nomination.NominationTeamNames[2]['GOM'] + '</td></tr><br>' +

    '<tr><td style="padding-bottom:15px; color:#EEE; text-decoration:none; font-family:\'Helvetica Neue\', Helvetica, Arial, sans-serif; font-size:16px; text-align:center" align="center">' +
    '<a style="color:#EEE; background-color: blue; padding: 10px; text-decoration:none; font-family:\'Helvetica Neue\', Helvetica, Arial, sans-serif; font-size:15px; text-align:center;" href="' + nomination.reviewLink + '" target="_blank"><strong>Click here to view the nominations</strong></a></td></tr>' +
    '<tr><td><hr>Thank you, we value the difference you make.<BR>Should you require assistance, please email: ThinkTank@multichoice.co.za</td></tr>' +
    '<tr><td><img src="https://thinktankapi.multichoice.com/wp-content/uploads/2018/12/Logo-footer.png" width="600" height="45" alt="Logo compilation"></td></tr><tr><td>&nbsp;</td></tr><tr>' +
    '<td align="center" style="color:#666; font-size:12px; text-align:center; font-family:Gotham, \'Helvetica Neue\', Helvetica, Arial, sans-serif">Copyright © MultiChoice. All rights reserved</td></tr></tbody></table></body>'
  }  
}



// WEBPACK FOOTER //
// ./src/helpers/NominationNotification.js